export const BASE_URL = '';
export const APP_URL = 'accounts';